<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="类型名称">
              <el-input clearable v-model.trim="where.type_name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="类型编码">
              <el-input clearable v-model.trim="where.channel_code" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="类型状态">
              <el-select clearable class="ele-block" v-model="where.status" placeholder="请选择">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :selection.sync="selection"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)"
            v-if="permission.includes('sys:type:add')">添加</el-button>
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            class="ele-btn-icon"
            :disabled="!selection.length"
            @click="removeBatch"
            v-if="permission.includes('sys:type:dall')">删除</el-button>
          <el-button
            size="small"
            type="warning"
            icon="el-icon-setting"
            class="ele-btn-icon"
            @click="showTypeNameConfig = true"
            v-if="permission.includes('sys:type:edit')">配置类型</el-button>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-message"
            class="ele-btn-icon"
            @click="showDayCut = true"
            v-if="permission.includes('sys:type:edit')">日切维护</el-button>
        </template>
        <template slot="status" slot-scope="{ row }">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="editStatus(row)"
            v-if="permission.includes('sys:type:status')" />
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
            v-if="permission.includes('sys:type:edit')">编辑</el-button>
          <el-button size="small" type="danger" class="ele-btn-icon" @click="remove(row)"
            v-if="permission.includes('sys:type:delete')">删除</el-button>
          <el-button size="small" type="primary" class="ele-btn-icon" @click="showRoundEdit(row)"
            v-if="permission.includes('sys:type:edit')">轮询</el-button>
        </template>
      </ele-pro-table>
    </el-card>

    <type-edit :data="current" :visible.sync="showEdit" @done="reload" />
    <round-edit :data="current" :visible.sync="roundEdit" @done="reload" />
    <type-name-config :visible.sync="showTypeNameConfig" />
    <day-cut-dialog :visible.sync="showDayCut" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { loadDictOptions } from '@/utils/dict';
import TypeEdit from './type-edit';
import RoundEdit from './round-edit';
import TypeNameConfig from './type-name-config';
import DayCutDialog from './day-cut-dialog';

export default {
  name: 'ChannelType',
  components: {
    TypeEdit,
    RoundEdit,
    TypeNameConfig,
    DayCutDialog
  },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/channeltype/index',
      columns: [
        {
          columnKey: 'selection',
          type: 'selection',
          width: 45,
          align: 'center',
          fixed: 'left'
        },
        {
          prop: 'channel_name',
          label: '类型名称',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center'
        },
        {
          prop: 'channel_code',
          label: '类型编码',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center'
        },
        {
          prop: 'status',
          label: '类型状态',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
          slot: 'status'
        },
        {
          columnKey: 'action',
          label: '操作',
          width: 250,
          align: 'center',
          resizable: false,
          slot: 'action',
          fixed: 'right'
        }
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false,
      roundEdit: false,
      showTypeNameConfig: false,
      showDayCut: false,
      statusOptions: []
    };
  },
  mounted() {
    loadDictOptions('switch_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    remove(row) {
      this.$confirm('此操作会删除多张表数据，请谨慎操作！是否继续？', '删除确认', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/channeltype/delete', { id: row.id }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的分类吗?', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/channeltype/delete', {
          id: this.selection.map((d) => d.id)
        }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      const prev = row.status === 1 ? 2 : 1;
      this.$http.post('/channeltype/status', {
        id: row.id,
        status: row.status
      }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = prev;
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        row.status = prev;
        this.$message.error(e.message);
      });
    },
    showRoundEdit(row) {
      this.current = row;
      this.roundEdit = true;
    }
  }
};
</script>
